const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('ernestdefoe-parley', 'forum/components/RoomTile');